import React, { useEffect, useState } from "react";
import { testimonialsData } from "../../../Mock/Home";
import axios from "axios";
import Loading from "../../../utils/Loader/Loading";
import TestimonialsSlider from "../../../main/funnel/Testimonials/Sliders/TestimonialsSlider";

const TestimonialsMain = () => {
  let [state, setState] = useState([]);
  let [isLoading, setIsLoading] = useState(true);
  let [isError, setIsError] = useState(false);

  useEffect(() => {
    let fetchCards = async () => {
      try {
        let response = await axios.get(
          `https://vercel-deployment-w4ja.onrender.com/api/get_all_reviews`
        );
        setState(response.data.data);
      } catch (error) {
        console.log(error);
        setIsError(true);
      } finally {
        setIsLoading(false);
      }
    };
    fetchCards();
  }, []);

  return (
    <>
      {" "}
      {isLoading && <Loading />}
      {!isLoading && !isError && state.length !== 0 && (
        <div className="max-w-7xl m-auto mt-16 relative max-sm:px-5">
          <h1 className="font-semibold text-2xl text-[#2C3E50] mb-10 max-sm:text-lg">
            Testimonials from Faculty and Researchers
          </h1>
          <div className="relative mx-3">
            <TestimonialsSlider data={state} />
          </div>
        </div>
      )}
      {isError && "Error Occurred"}
    </>
  );
};

export default TestimonialsMain;
